import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { GenerateOrderDiscountCodeComponent } from './generate-order-discount-code.component';

const routes: Routes = [
  {
    path: '',
    component: GenerateOrderDiscountCodeComponent,
    data: { title: 'Generate Order Discount Code' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GenerateOrderDiscountCodeRoutingModule {}

@NgModule({
  imports: [
    GenerateOrderDiscountCodeRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [GenerateOrderDiscountCodeComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GenerateOrderDiscountCodeModule {}
